import { UIElement } from './uiElement';
import { IUIElementOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';
import { IEvent } from '../../../interfaces';
import { Event } from '../..';

export class LabelEdit extends UIElement<string | number> {
    protected click: () => void;
    protected title: string | KnockoutObservable<string>;
    protected onClick: Event<void>;
    public get Clicked(): IEvent<void> {
        return this.onClick;
    }

    public isEditable: KnockoutObservable<boolean>;

    constructor(
        id: string,
        label: string,
        value: string | number | KnockoutObservable<string | number>,
        options?: IUIElementOptions
    ) {
        options = $.extend(
            true,
            {},
            <IUIElementOptions>{
                template: Templates.layouts_uiElements_noValidation,
                widget: {
                    widget: Templates.widgets_labelEdit
                }
            },
            options || {}
        );
        super(id, label, value, options);
        this.onClick = new Event<void>();
        this.click = () => {
            this.onClick.notify();
        };
        this.title = options.title;
        this.isEditable = ko.observable<boolean>(true);
    }
}
